<script lang="ts">
    import type { PostTeaserMiniFragment, ExhibitionTeaserMiniFragment } from '$gen/graphql';
    import { routes } from '$lib/routes';

    export let posts: (PostTeaserMiniFragment | ExhibitionTeaserMiniFragment)[] = [];
</script>

<section class="mb-5 flex flex-col gap-5 lg:flex-row">
    <div class="min-w-max">
        <h4>More KUBAPARIS</h4>
    </div>
    <div class="grid w-full grid-cols-1 gap-5 md:grid-cols-3">
        {#each posts as post}
            <article class="h-min self-end text-sm">
                <a
                    class="flex max-h-full flex-col"
                    href={post.__typename === 'posts_default_Entry'
                        ? `/${post.uri}`
                        : routes.submission(post.id, post.title)}
                    sveltekit:prefetch
                >
                    {#if post.__typename === 'posts_default_Entry'}
                        {#each post.keyImage.slice(0) as img}
                            {#if img.__typename === 'assets_Asset'}
                                <img
                                    src={img.url}
                                    srcset={img.srcset}
                                    width={img.width}
                                    height={img.height}
                                    alt={img.title}
                                />
                            {/if}
                        {/each}
                    {:else if post.__typename === 'exhibition_Submission'}
                        {#each post.keyImage.slice(0) as img}
                            {#if img.__typename === 'submissions_Asset'}
                                <img
                                    src={img.url}
                                    srcset={img.srcset}
                                    width={img.width}
                                    height={img.height}
                                    alt={img.title}
                                />
                            {/if}
                        {/each}
                    {/if}
                    <div class="mt-1 h-min shrink leading-3 lg:mb-5 lg:h-12">
                        {post.title}
                    </div>
                </a>
            </article>
        {/each}
    </div>
</section>

<style>
    img {
        max-height: 100%;
        width: auto;
    }
</style>
